import {
  HStack,
  RefreshControl,
  View,
  VStack
} from "@gluestack-ui/themed";
import { DraftHeader } from "./components/DraftHeader";

import { ProposalGroup } from "@repo/core/components/layout/ProposalGroup";

import { useDraftController } from "./controller";
import { ScrollView } from "@repo/core/components/layout/ScrollView";

import { ActionSheet } from "@repo/core/components/layout/Actionsheet";
import { Text } from "@gluestack-ui/themed";
import { ProposalOptionsItem } from "@repo/core/screens/Proposals/screens/ProposalsSearch/components/ProposalOptionsSheet/ProposalOptionsItem";

import { DraftLoading } from "./loading";
import { StatusBar } from "@repo/core/components/layout/StatusBar";
import { AlertModal } from "@repo/core/components/layout/ModalTemplate/AlertModal";
import { Button } from "@repo/core/components/core/Button";
import { StatusBarVariantEnum } from "@repo/core/components/layout/StatusBar/types";
import { ProposalsDraftProps } from "./types";

function DraftScreen(_props: ProposalsDraftProps) {
  const {
    proposals,
    alertModalRef,
    handleDeleteDraft,
    handleCancelDeleteDraft,
    actionSheetRef,
    handleOnPressOption,
    handleOpenOptions,
    proposalOptions,
    isMobile,
    refreshing,
    isLoading,
    lastUpdated,
    onRefresh,
    searchText,
    setSearchText
  } = useDraftController();

  return (
    <>
      <StatusBar
        showCustomStatusBar
        statusBarVariant={StatusBarVariantEnum.GREEN}
      />
      <ScrollView
        flex={1}
        bgColor="$backgroundLight100"
        refreshControl={
          <RefreshControl
            bg="$primary700"
            refreshing={refreshing}
            onRefresh={onRefresh}
          />
        }
      >
        <View w="$full">
          <DraftHeader
            onRefresh={onRefresh}
            lastUpdated={lastUpdated}
            searchText={searchText}
            setSearchText={setSearchText}
          />
          <VStack p="$6" bgColor="$backgroundLight100">
            {isLoading || (!isMobile && refreshing) ? (
              <DraftLoading />
            ) : (
              <ProposalGroup
                items={proposals}
                onPressOption={handleOpenOptions}
              />
            )}
          </VStack>
        </View>
      </ScrollView>
      <ActionSheet ref={actionSheetRef}>
        <VStack w="$full" p="$2" pb="$6" mb="$2">
          <VStack mb="$4" px="$3">
            <Text fontSize="$md" fontWeight={500} color="$textLight600">
              Opções
            </Text>
          </VStack>

          <VStack>
            {proposalOptions?.map((option) => (
              <ProposalOptionsItem
                key={option.label}
                {...option}
                onPress={handleOnPressOption}
              />
            ))}
          </VStack>
        </VStack>
      </ActionSheet>
      <AlertModal
        maxWidth={427}
        ref={alertModalRef}
        headerTitle="Descartar proposta"
        description="Deseja sair e descartar a proposta?"
      >
        <HStack w="$full" p="$4" justifyContent="flex-end" gap="$2">
          <Button
            text="Manter rascunho"
            variant="outline"
            size="sm"
            onPress={handleCancelDeleteDraft}
            action="secondary"
          />
          <Button
            text="Descartar"
            action="negative"
            size="sm"
            onPress={handleDeleteDraft}
          />
        </HStack>
      </AlertModal>
    </>
  );
}

export default DraftScreen;
